import JobApplicationRelocation from './JobApplicationRelocation.component';

export default JobApplicationRelocation;